module.exports = __webpack_public_path__ + "img/question.bb79bbf1.svg";